import { codeFont } from '../../utils/fonts';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// The unified part-source visual language, extracted from the OEM "Mistä osa otetaan?"
// picker (PartSwapModal) so every part-picking surface — OEM schedules, the AI work-order
// suggestion dialog, future pickers — sections candidates the same way: an uppercase source
// header with a one-line plain-language explanation of WHERE these parts come from and on
// what grounds they should fit, then bordered candidate rows.

export function PartSectionHeader({ icon, title, help }) {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
        }}
      >
        {icon}
        {title}
      </Typography>
      {help && (
        <Typography sx={{ fontSize: 11, color: 'text.disabled', mb: 1, mt: 0.25 }}>{help}</Typography>
      )}
    </Box>
  );
}

// One candidate row. `leading` (e.g. a checkbox) and `trailing` (price / qty controls) are
// free slots so single-pick surfaces (click the row) and multi-pick surfaces (checkbox per
// row) share the same body. When `onClick` is given the whole row is the hit target.
export function PartCandidateRow({ primary, secondary, leading, trailing, onClick, disabled, testId }) {
  return (
    <Box
      onClick={disabled ? undefined : onClick}
      data-testid={testId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: '10px 14px',
        border: 1,
        borderColor: 'divider',
        borderRadius: '10px',
        cursor: onClick && !disabled ? 'pointer' : 'default',
        opacity: disabled ? 0.55 : 1,
        '&:hover': onClick && !disabled ? { bgcolor: '#f5f9ff', borderColor: 'secondary.main' } : {},
        transition: 'all 150ms',
      }}
    >
      {leading}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {primary}
        </Typography>
        {secondary && (
          <Typography sx={{ fontSize: 11, color: 'text.secondary', ...codeFont, mt: 0.25 }}>
            {secondary}
          </Typography>
        )}
      </Box>
      {trailing && <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 1 }}>{trailing}</Box>}
    </Box>
  );
}
